import { render } from "./ProjectElectroOptic.vue?vue&type=template&id=de921a60"
import script from "./ProjectElectroOptic.vue?vue&type=script&lang=js"
export * from "./ProjectElectroOptic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__